import { Input } from "../../../../components/global";
import { TextArea } from "../../../../components/global/textarea";

const ZoneType = () => (
    <Input name="zonas_tipo" type="text" label="Nome Zona, Eixou ou Setor" />
);

const ZoneCode = () => <Input name="zonas_codigo" type="text" label="Sigla" />;

const ZoneDescription = () => (
    <div className="row-span-3 flex flex-col">
        <TextArea // input grande
            name="zonas_descricao"
            label="Descrição (características predominantes)"
        />
    </div>
);

const ZonePermittedLaws = () => (
    <Input
        name="zonas_leis_permitidas"
        type="text"
        label="Uso - Permitido | Adequado"
    />
);

const ZonePermissiveLaws = () => (
    <Input
        name="zonas_leis_permissivas"
        type="text"
        label="Uso - Permissivo | Condicionado"
    />
);

const ZoneFrobiddenLaws = () => (
    <Input name="zonas_leis_proibidas" type="text" label="Uso - Proibido" />
);

const ZoneCNAE = () => (
    <Input name="zonas_cnaes_permitidos" type="text" label="CNAEs Permitidos" />
);

export const FilterInputs = [
    ZoneCode,
    ZoneType,
    ZoneDescription,
    ZonePermittedLaws,
    ZonePermissiveLaws,
    ZoneFrobiddenLaws,
    ZoneCNAE,
];

export const CreateInputs = [
    ZoneCode,
    ZoneType,
    ZoneDescription,
    ZonePermittedLaws,
    ZonePermissiveLaws,
    ZoneFrobiddenLaws,
    ZoneCNAE,
];

export const UpdateInputs = [
    ZoneCode,
    ZoneType,
    ZoneDescription,
    ZonePermittedLaws,
    ZonePermissiveLaws,
    ZoneFrobiddenLaws,
    ZoneCNAE,
];
